<template>
  <!-- 行业资质  -->
  <div>
    <a-modal
      title="修改"
      :visible="visible"
      @ok="closeFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
      :footer="null"
    >
      <span>类目：{{row.category1Name}} > {{row.category2Name}} > {{row.category3Name}}</span>
      <a-button type="primary" style="float:right" @click="addfn" v-hasPermi="['community:localQualify:addCert']">添加</a-button>
      <br/><br/>
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="false"
      >
        <template slot="isSms" slot-scope="text, record">
          <a-checkbox :checked="record.isRequire == '1'" @change="onSmsChange($event,record)"/>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-button type="link"  @click="deletefun($event,record)">删除</a-button>
        </template>
      </a-table>
      <add-qualification-model-vue ref='add' :id=id @update = 'update'></add-qualification-model-vue>
    </a-modal>
  </div>
</template>

<script>
import addQualificationModelVue from './addQualificationModel.vue';
export default {
  name: 'industryQualifications',
  components: {addQualificationModelVue},
  data () {
    return {
      row: undefined,
      id: undefined,
      visible: false,
      columns: [
        {
          title: '行业资质',
          dataIndex: 'title',
          align: '',
          width: '200'
        },
        {
          title: '必填项',
          dataIndex: 'isRequire',
          scopedSlots: { customRender: 'isSms' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: '',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      searchParams: {
        contractYear: undefined
      },

      listApi: {
        url: '',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }

    };
  },

  created () {},
  methods: {
    update () {
      this.$get({
        url: '/local/qualify/' + this.row.qualifyId,
        params: { }
      }).then((res) => {
        this.dataSource = res.data;
        this.$message.success('操作成功');
      });
    },
    show (obj) {
      this.row = obj;
      this.id = obj.category3Id;
      this.$get({
        url: '/local/qualify/' + obj.qualifyId,
        params: { }
      }).then((res) => {
        this.dataSource = res.data;
        this.visible = true;
      });
    },
    addfn () {
      this.$refs.add.visible = true;
    },
    deletefun (e, item) {
      this.$delete({
        url: '/local/qualify/cert/' + item.qualifyCertId,
        params: { }
      }).then((res) => {
        this.update();
      });
    },
    onSmsChange (e, item) {
      const val = e.target.checked ? '1' : '0';
      this.$put({
        url: '/local/qualify/cert/' + item.qualifyCertId,
        params: { isRequire: val}
      }).then((res) => {
        this.update();
      });
    },
    closeFun () {
      let length = this.dataSource.length;
      if (length == 0) {
        this.$confirm({
          title: `行业资质为空将删除该${this.row.category3Name}记录，是否继续？`,
          centered: true,
          onOk: (close) => {
            this.$delete({
              url: '/local/qualify/' + this.row.qualifyId
            }).then(({ data }) => {
              this.$message.success('删除成功');
              this.$parent.$refs.table.getTableList();
            });
            this.visible = false;
            close();
          }
        });
      } else {
        this.$parent.$refs.table.getTableList();
        this.visible = false;
      }
    },
    goDetail () {
      this.$router.push({ path: 'local/contractReview/detail' });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style scoped>
</style>
